import { normalizeNucleus } from 'nmr-processing';
import { maybeAdd } from '../../utilities/getInfoFromMeta';
export function getInfo(varianOutput, logger) {
    const { meta: originalMetadata, procpar } = varianOutput;
    const procPar = {}; //
    for (const par of procpar) {
        procPar[par.name] = par.values;
    }
    const info = {};
    const meta = {};
    const { np, solvent, sfrq, reffrq, temp, rp, sw, rfl, rfp } = procPar;
    maybeAdd(info, 'numberOfPoints', np && Number(getFirstIfArray(np)) / 2);
    maybeAdd(info, 'solvent', getFirstIfArray(solvent));
    maybeAdd(info, 'originFrequency', getFirstIfArray(sfrq));
    maybeAdd(info, 'baseFrequency', getFirstIfArray(reffrq));
    if (isNaN(info.originFrequency) || info.originFrequency === 0) {
        info.originFrequency = 400;
        logger?.warn('The frequency could not be determined and was set to 400MHz');
    }
    maybeAdd(info, 'temperature', getFirstIfArray(temp));
    maybeAdd(info, 'phc0', rp && -Number(rp[0]));
    maybeAdd(meta, 'rfl', rfl && Number(getFirstIfArray(rfl)));
    maybeAdd(meta, 'rfp', rfp && Number(getFirstIfArray(rfp)));
    maybeAdd(meta, 'sw', sw && Number(getFirstIfArray(sw)));
    for (const key in meta) {
        const value = meta[key];
        if (Array.isArray(value) && value.length === 1)
            meta[key] = value[0];
    }
    if (!('baseFrequency' in info) && 'originFrequency' in info) {
        const originFrequency = parseFloat(info.originFrequency);
        if (['sw', 'rfl', 'rfp'].every((key) => key in meta)) {
            const { sw = 1, rfl = 1, rfp = 1, } = getNumberParameters(meta, ['sw', 'rfl', 'rfp']);
            maybeAdd(info, 'baseFrequency', originFrequency - (sw / 2 - rfl + rfp) / 1e6);
        }
        else {
            maybeAdd(info, 'baseFrequency', originFrequency);
        }
    }
    const { baseFrequency, originFrequency } = info;
    maybeAdd(info, 'frequencyOffset', (originFrequency - baseFrequency) * 1e6);
    maybeAdd(info, 'spectralWidth', sw && Number(sw[0]) / info.baseFrequency);
    for (const key in info) {
        if (info[key].length === 1)
            info[key] = info[key][0];
    }
    if (procPar.tn) {
        info.nucleus = procPar.tn.map(normalizeNucleus);
    }
    info.dimension = 1;
    info.isFid = !originalMetadata.status.isSpectrum;
    return { info, meta: { ...meta, ...originalMetadata } };
}
function getFirstIfArray(data) {
    return data && (Array.isArray(data) ? data[0] : data);
}
function getNumberParameters(obj, keys) {
    const result = {};
    for (const key of keys) {
        const value = obj[key];
        if (value) {
            if (typeof value === 'number') {
                result[key] = value;
            }
        }
    }
    return result;
}
//# sourceMappingURL=getInfo.js.map